import request from '@/utils/request';
import { iResult, iUserInfo } from '@/interface/result';
import { iAdparams } from '@/interface/exchange-code';
import { AxiosPromise } from 'axios';
import { iExchangeCode, iCodeQuery, iChannelSearch } from '@/interface/exchange-code';
import { iTimeParams } from '@/interface/exchange-code';
/**
 * 批量生成兑换码
 * @param data iExchangeCode
 */
export const postExchangeCode = (data: iExchangeCode) =>
  request({
    url: '/api/v1/omc/card_generate',
    method: 'post',
    data,
  });

/**
 * 兑换码列表
 * @param params iCodeQuery
 */
export const getCodeList = (params: iCodeQuery) =>
  request({
    params,
    url: '/api/v1/omc/card_list',
  });

/**
 * 导出兑换码
 * @param params { cnt: number; version: number }
 */
export const getExcelTable = (params: { cnt: number; version: number }) =>
  request({
    params,
    url: '/api/v1/omc/card_export',
  });

/**
 * 锁定兑换码
 * @param params {id:string;is_lock:number}
 */
export const lockCode = (params: { id: string; is_lock: number }) =>
  request({
    params,
    url: '/api/v1/omc/card_lock',
  });
/* OMC 添加和编辑广告
 * @param data
 */
export const adAddEdit = (data: iAdparams): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/adv/save',
    method: 'post',
  });
/**
 * OMC 获取广告列表
 * @param data
 */
export const getAdList = (params: any): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/adv/advs',
    method: 'get',
  });
/**
 * 营销管理-推广连接-列举-汇总
 * @param params
 */
export const getChannelSummary = (params: iTimeParams): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/marketing/channel/summary',
  });
/**
 * 营销管理-推广连接-列举
 * @param params
 */
export const getChannelList = (params: iChannelSearch): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/marketing/channel',
  });
/**
 * 营销管理-推广连接-新建推广
 * @param data { name: string; coin: number }
 */
export const addChannelData = (data: { name: string; coin: number }): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/marketing/channel',
    method: 'post',
  });
/**
 * 营销管理-推广连接-编辑推广
 * @param data { name: string; coin: number }
 */
export const editChannelData = (data: { name: string; coin: number; code: string }): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/marketing/channel',
    method: 'put',
  });
/**
 * [消息推送] 添加推送
 * @param data { name: string; coin: number }
 */
export const addMsgPush = (data: any): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/msg_push',
    method: 'post',
  });
/**
 * [消息推送] 推送列表
 * @param data { name: string; coin: number }
 */
export const getMsgList = (params: any): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/msg_push/page_list',
    method: 'get',
  });
/**
 * [消息推送] 变更状态
 * @param data { name: string; coin: number }
 */
export const editMsgStatus = (params: any, data: any): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/msg_push/status/' + params,
    method: 'put',
  });
/**
 * [消息推送] 查看详情
 * @param data { name: string; coin: number }
 */
export const getMsgDetail = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/msg_push/one/' + params,
  });
